{{ 'Project::VirtualAgentTrainingFailed' | abpLocalization: notification.name }}
